import BigNumber from 'bignumber.js';
import { DlVault } from 'types/contracts';

export interface PreviewStakeRewardsInput {
  dlVaultContract: DlVault;
  accountAddress: string;
  vaultId?: string;
  amount: BigNumber;
}

export type PreviewStakeRewardsOutput = {
  estimatedRewards: BigNumber;
  currentApy: BigNumber;
  projectedApy: BigNumber;
  stakingPeriod: number;
  minimumStakeAmount: BigNumber;
  totalStaked: BigNumber;
  userStaked: BigNumber;
  rewardTokenSymbol: string;
  dailyReward: BigNumber;
  totalReward: BigNumber;
};

const previewStakeRewards = async ({
  dlVaultContract,
  accountAddress,
  vaultId = '0',
  amount,
}: PreviewStakeRewardsInput): Promise<PreviewStakeRewardsOutput> => {
  try {
    // 获取用户当前信息
    const userInfo = await dlVaultContract.methods.getUserInfo(accountAddress).call();

    // 计算预估奖励基于 amount 和当前 dailyReward 比例
    const currentStake = new BigNumber(userInfo.stake || '0');
    const currentDailyReward = new BigNumber(userInfo.dailyReward || '0');

    // 如果当前没有质押，使用默认比率计算
    let estimatedDailyReward = new BigNumber('0');
    if (currentStake.isGreaterThan(0) && currentDailyReward.isGreaterThan(0)) {
      // 基于当前比率计算
      const ratio = currentDailyReward.dividedBy(currentStake);
      estimatedDailyReward = amount.multipliedBy(ratio);
    } else {
      // 使用默认12.5% APY计算日收益
      estimatedDailyReward = amount.multipliedBy(0.125).dividedBy(365);
    }

    const estimatedYearlyReward = estimatedDailyReward.multipliedBy(365);
    const currentApy = currentStake.isGreaterThan(0)
      ? currentDailyReward.multipliedBy(365).dividedBy(currentStake).multipliedBy(100)
      : new BigNumber('12.5');

    return {
      estimatedRewards: estimatedYearlyReward,
      currentApy,
      projectedApy: currentApy,
      stakingPeriod: 365, // 一年
      minimumStakeAmount: new BigNumber('100'),
      totalStaked: new BigNumber(userInfo.totalRewards || '0'),
      userStaked: currentStake,
      rewardTokenSymbol: 'USDT',
      dailyReward: estimatedDailyReward,
      totalReward: new BigNumber(userInfo.totalRewards || '0'),
    };
  } catch (error) {
    console.error('Error previewing stake rewards:', error);

    // 返回默认值
    const estimatedDailyReward = amount.multipliedBy(0.125).dividedBy(365);
    return {
      estimatedRewards: estimatedDailyReward.multipliedBy(365),
      currentApy: new BigNumber('12.5'),
      projectedApy: new BigNumber('12.5'),
      stakingPeriod: 365,
      minimumStakeAmount: new BigNumber('100'),
      totalStaked: new BigNumber('0'),
      userStaked: new BigNumber('0'),
      rewardTokenSymbol: 'USDT',
      dailyReward: estimatedDailyReward,
      totalReward: new BigNumber('0'),
    };
  }
};

export default previewStakeRewards; 